import React, { ComponentState, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { ClientService } from "src/services/clientService";
import APP_ROUTES from "src/helper/app-routes";
import { renderErrors } from "src/helper/error-message-helper";
import NotificationManager from "react-notifications/lib/NotificationManager";

import { NichqHeader } from "./Nichq-heads";
import ClientQuestionnaireService from "./functionToSaveQuestionnaireFromPortal";






export const WCC_Scale = ({ WCC, response, interfered, isPrint, questionId, isFromCP, queId, token }) => {

  const { state } = useLocation();
  const selectedClientId = useSelector((state: ComponentState) => state.selectedClientId);
  const navigate = useNavigate();

  const [wcc, setWcc] = useState<any[]>([]);

  const handleSaveFromPortal = async () => {
    ClientQuestionnaireService.updatequestionnaireFromPortal(selectedClientId, 0, [...wcc], queId, token)
  }

  const handleCompleteFromPortal = async () => {
    try {
      ClientQuestionnaireService.completeQuestionnaireFromPortal(false, queId, selectedClientId, 0, [...wcc],  {isCompleted: true, inProgress: false, sentToClientPortal: null}, token)
    } catch (error) {
      console.error('Error completing client questionnaire:', error);
      NotificationManager.error('Failed to complete client questionnaire');
    }
  };



  useEffect(() => {

    const Wcc = WCC.map((item) => {
      const foundItem = response.find((i) => i.questionId === item.questionId);
      if (foundItem) {
        if (item.type === "question") {
          if (foundItem.value) {
            return { ...item, isSelected: true, value: foundItem.value };
          } else {
            return { ...item, isSelected: false, value: "" };
          }
        }
        return { ...item, ...foundItem };
      } else {
        return item;
      }
    });


    setWcc(Wcc);





  }, [response])

  const handleSubmit = async () => {
    await ClientService.insertClientQuestionnaire(
      selectedClientId, 0,
      [
        ...wcc,
      ],
      questionId
    )
      .then((result:any) => {
        let questionList = result.resultData;
        navigate(APP_ROUTES.QUESTIONNAIRE);
        NotificationManager.success("Add successfully");
      })
      .catch((error) => {
        // setLoading(false);
        renderErrors(error.message);
      });
  };

  return (
    <div className="ml-3">

      <div className="mt-4 head-4">
        WAYS OF COPING (Revised)
      </div>

      <div>
        <label>


        Please read each item below and indicate, by using the following rating scale, to what extent you
        used it in the situation you have just described.
        </label>
      </div>


      {
        wcc.length > 0 &&
        <div className="row mt-4">
          <NichqHeader

            title={""}
            disabled={isFromCP ? false : (response && response.length>0)}
            subTitle={''}
            listItems={wcc}
            setListItems={setWcc}
          />
        </div>
      }




{isFromCP ? (
          <div className="text-start mt-3 col-12">
           <button onClick={handleCompleteFromPortal} className="submitButon">
            Save & Complete
          </button>
          <button onClick={handleSaveFromPortal} className="cancelBtn">
            Save progress
          </button>
          </div>
        ) : state == null && !isPrint ? (
          <div className="text-start mt-3 col-12">
            <button onClick={handleSubmit} className="submitButon">
              Submit
            </button>
          </div>
        ) : null}


    </div>

  )

}



